import React from "react";
import { Container } from "react-bootstrap";
import { useMyDpdTheme } from "@dpdgroupuk/mydpd-ui";
import styles from "./LoginLogo.module.scss";

const LoginLogo = () => {
  const theme = useMyDpdTheme();
  return /*#__PURE__*/React.createElement(Container, {
    className: "py-2",
    as: "header"
  }, /*#__PURE__*/React.createElement("a", {
    href: theme.dpdDomain
  }, /*#__PURE__*/React.createElement("img", {
    className: styles.logoImg,
    src: theme.logoImg,
    alt: "DPD Logo"
  })));
};

export default LoginLogo;